// @flow
export const ADD_BU_FILTER = 'filters/ADD_BU_FILTER';
export const REMOVE_BU_FILTER = 'filters/REMOVE_BU_FILTER';
export const CLEAR_BU_FILTERS = 'filters/CLEAR_BU_FILTERS';
export const ADD_D_FILTER = 'filters/ADD_D_FILTER';
export const REMOVE_D_FILTER = 'filters/REMOVE_D_FILTER';
export const CLEAR_D_FILTERS = 'filters/CLEAR_D_FILTERS';
export const ADD_FE_FILTER = 'filters/ADD_FE_FILTER';
export const REMOVE_FE_FILTER = 'filters/REMOVE_FE_FILTER';
export const CLEAR_FE_FILTERS = 'filters/CLEAR_FE_FILTERS';
export const ADD_TYPE_FILTER = 'filters/ADD_TYPE_FILTER';
export const REMOVE_TYPE_FILTER = 'filters/REMOVE_TYPE_FILTER';
export const CLEAR_TYPE_FILTERS = 'filters/CLEAR_TYPE_FILTERS';
export const ADD_DATE_FILTER = 'filters/ADD_DATE_FILTER';
export const REMOVE_DATE_FILTER = 'filters/REMOVE_DATE_FILTER';
export const CLEAR_DATE_FILTERS = 'filters/CLEAR_DATE_FILTERS';

export function addBUfilter( filter ) {
    return {
        type: ADD_BU_FILTER,
        filter: filter
    };
}

export function removeBUfilter( filter ) {
    return {
        type: REMOVE_BU_FILTER,
        filter: filter
    };
}

export function clearBUfilters() {
    return {
        type: CLEAR_BU_FILTERS
    };
}

export function addDfilter( filter ) {
    return {
        type: ADD_D_FILTER,
        filter: filter
    };
}

export function removeDfilter( filter ) {
    return {
        type: REMOVE_D_FILTER,
        filter: filter
    };
}

export function clearDfilters() {
    return {
        type: CLEAR_D_FILTERS
    };
}

export function addFEfilter( filter ) {
    return {
        type: ADD_FE_FILTER,
        filter: filter
    };
}

export function removeFEfilter( filter ) {
    return {
        type: REMOVE_FE_FILTER,
        filter: filter
    };
}

export function clearFEfilters() {
    return {
        type: CLEAR_FE_FILTERS
    };
}

export function addTypeFilter( filter ) {
    return {
        type: ADD_TYPE_FILTER,
        filter: filter
    };
}

export function removeTypeFilter( filter ) {
    return {
        type: REMOVE_TYPE_FILTER,
        filter: filter
    };
}

export function clearTypeFilters() {
    return {
        type: CLEAR_TYPE_FILTERS
    };
}

export function addDateFilter( filter ) {
    return {
        type: ADD_DATE_FILTER,
        filter: filter
    };
}

export function removeDateFilter( filter ) {
    return {
        type: REMOVE_DATE_FILTER,
        filter: filter
    };
}

export function clearDateFilters() {
    return {
        type: CLEAR_DATE_FILTERS
    };
}